module.exports = __webpack_public_path__ + "static/finding_gold_google_aofty-7cee3d48ae3fa1f09dd0859f04fd587d.png";